import * as React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from "react-router-dom";
import * as styles from "./Details.module.scss";

const DetailsBtn = ({ text, path }) => (
  <div className={styles.root}>
    <NavLink to={path} className={styles.btn}>
      <span className={styles.text}>{text}</span>
    </NavLink>
  </div>
);

DetailsBtn.propTypes = {
  text: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired
};

export default DetailsBtn;